<script setup lang="ts">
import { RootWidget } from "@astrox/ui-vue";
import { usePageStore } from "@astrox/ui-vue/store";

const pageStore = usePageStore();
</script>

<template>
  <RootWidget is-ready :layout="pageStore.layout" :is-loading="pageStore.isLoading"></RootWidget>
</template>
